import { handleResponseOld, makePost } from './helpers';

/**
 * @category Category API
 * @see fetchCategoriesByIds
 */
type FetchCategoriesByIdsParams = {
    authToken: string;
    categoryIds: number[];
    deployment: string;
};
/**
 * Fetches Category descriptions by given categoryIds
 * @function fetchCategoriesByIds
 * @category Category API
 * @param {FetchCategoriesByIdsParams}
 * @see https://api-DEPLOYMENT.liveauctioneers.com/category-api/getcategorydescription
 * @see https://console.aws.amazon.com/apigateway/home?region=us-east-1#/apis/qdhsknmtx7/resources/pdxwjs/methods/POST
 * @see https://github.com/LIVEauctioneers/category-api/tree/master/functions/GetCategoryDescription
 */
export const fetchCategoriesByIds = ({ authToken, categoryIds, deployment }: FetchCategoriesByIdsParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makePost({ authToken, deployment, path: '<CATEGORY-API>/getcategorydescription' });
        request.send({ categoryIds });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });
